import { AxiosPromise } from 'axios';

import { Breed, GetBreedsParams, PaginatedResponse } from 'shared/api';
import { apiInstance } from 'shared/api/typicode/base';

const BASE_URL = '/breeds';

/**
 * Получение списка пород с пагинацией и фильтрацией
 * @param params - Параметры запроса (фильтрация, сортировка, пагинация). Обязательно: specie (тип животного)
 * @returns Promise с ответом, содержащим массив пород и информацию о пагинации
 */
export const getBreeds = async (params: GetBreedsParams): AxiosPromise<PaginatedResponse<Breed>> =>
  apiInstance.get(`${BASE_URL}/admin`, {
    params,
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });

/**
 * Получение породы по идентификатору
 * @param id - Уникальный идентификатор породы
 * @returns Promise с данными породы
 */
export const getBreedById = async (id: string): AxiosPromise<Breed> =>
  apiInstance.get(`${BASE_URL}/${id}`, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });

/**
 * Добавление новой породы
 * @param data - Данные новой породы (без поля _id)
 * @returns Promise с данными созданной породы
 */
export const postBreed = async (data: Omit<Breed, '_id'>): AxiosPromise<Breed> =>
  apiInstance.post(`${BASE_URL}`, data, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });

/**
 * Обновление существующей породы
 * @param id - Уникальный идентификатор породы для обновления
 * @param data - Обновленные данные породы
 * @returns Promise с данными обновленной породы
 */
export const patchBreed = async (id: string, data: Breed): AxiosPromise<Breed> => {
  return apiInstance.patch(`${BASE_URL}/${id}`, data, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });
};

/**
 * Удаление породы по идентификатору
 * @param id - Уникальный идентификатор породы для удаления
 * @returns Promise с булевым значением, указывающим на успешность удаления
 */
export const deleteBreedById = async (id: string): AxiosPromise<boolean> =>
  apiInstance.delete(`${BASE_URL}/${id}`, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });
